import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { DataBusiness } from "../components/common/DataBusiness";
import { NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import { Customers } from "../components/common/Customers";
import { Countries } from "./Countries";
import { SliderService } from "./common/SliderService";
// video  3 4
import video from "./../assets/videos/video-3.mp4";
import videoWebm from "./../assets/videos/video-3.webm";
import bg_poster from "./../assets/imgs/bg_home.webp";
import scr_down from "./../assets/imgs/scr.gif";
import WhatsappSupport from "./whatsappSupport";

export const Home = () => {
  const [t] = useTranslation("global");

  const items = [
    { id: 1, title: t("offer.service_one") },
    { id: 2, title: t("offer.service_two") },
    // { id: 3, title: t("offer.service_three") },
    { id: 4, title: t("offer.service_four") },
    { id: 5, title: t("offer.service_five") },
    { id: 6, title: t("offer.service_six") },
    { id: 7, title: t("offer.service_seven") },
    { id: 8, title: t("offer.service_eight") },
  ];

  const [activeIndex, setActiveIndex] = React.useState(0);

  const next = () => {
    const randomIndex = Math.floor(Math.random() * items.length);
    setActiveIndex(randomIndex);
  };
  useEffect(() => {
    const interval = setInterval(next, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="wrapper_home" id="home">
        <div className="bg_video">
          <video autoPlay loop muted poster={bg_poster}>
            <source
              src={video}
              type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
            />
            <source src={videoWebm} type='video/webm; codecs="vp8, vorbis"' />
          </video>
        </div>
        <div className="container vh">
          <div className="content_home">
            <h6 className="mb-6 ttls_small">{t("home.title_welcome")}</h6>
            <h1 className="message ">{t("home.title_message")}</h1>
            <p className="paragraphs">{t("home.title_message_descrip")}</p>
          </div>
        </div>
        <div className="box_scr_down">
          <div className="label_sc">Scroll me</div>
          <img
            src={scr_down}
            alt="Conoce de marketing y tecnología, expertos en provocar ventas y la permanencia de sus clientes a través de soluciones digitales, incentivos y premios de las marcas más reconocidas."
          />
        </div>
      </section>
      <section className="wrapper_offer" id="offer">
        <div className="container">
          <div className="box_container">
            <div className="mb-5 col">
              <h6 className="ttls_small offer">{t("offer.we_offer")}</h6>
              <h3 className="mt-2 ttls ttls_sections">
                {t("offer.label_innovation")}{" "}
                <span className="bg_span lemon text-light">
                  {t("offer.label_technoloy")}
                </span>
              </h3>
              <p className="pb-4 mt-4 paragraphs">
                {t("offer.offer_descriptions")}
              </p>
              <div className="mt-5 ">
                <NavLink
                  className="btns btn_compress"
                  tag={Link}
                  to="/productos"
                >
                  <span>{t("offer.get_products")}</span>
                </NavLink>
              </div>
            </div>
            <div className="col">
              <div className="box_offer">
                {items.map((item, index) => (
                  <h2
                    className={`ttl__offer ${activeIndex === index ? "active" : ""}`}
                    key={item.id}
                  >
                    {item.title}
                  </h2>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <SliderService />
      {/* <Countries /> */}
      <DataBusiness />
      <Customers />
      <WhatsappSupport />
    </>
  );
};
